export interface DataEntity_Resolution_11_Interface {
    id: number,
    range_min:string,
    range_max:string,

  }
  
  export function Empty_DataEntity_Resolution_11_Interface(): DataEntity_Resolution_11_Interface {
    return {
      id: 0,
      range_min:'',
      range_max:'',
    }
  }